import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "";

function clearClientAuth() {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("me.username");
  localStorage.removeItem("me.role");
  localStorage.removeItem("me.store_name");
  localStorage.removeItem("session_only");

  sessionStorage.removeItem("access");
  sessionStorage.removeItem("refresh");

  window.dispatchEvent(new Event("localstorage-auth"));
}

export default function AppLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const requestedReturnTo = location.state?.returnTo;
  const returnTo =
    requestedReturnTo === "/app/carrello" ||
    requestedReturnTo === "/app/wallet"
      ? requestedReturnTo
      : "/app";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const access = localStorage.getItem("access");
    const role = (localStorage.getItem("me.role") || "").toUpperCase();

    if (access && (role === "CLIENTE" || role === "AGENTE" || role === "AZIENDA")) {
      navigate(role === "CLIENTE" ? returnTo : "/app", { replace: true });
    }
  }, [navigate, returnTo]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setErr("");

    const cleanUsername = username.trim();
    const cleanPassword = password.trim();

    if (!cleanUsername || !cleanPassword) {
      setErr("Inserisci username e password.");
      return;
    }

    setLoading(true);

    try {
      const tokenResponse = await fetch(`${API_URL}/api/token/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          username: cleanUsername,
          password: cleanPassword,
        }),
      });

      const tokenText = await tokenResponse.text();

      let tokenData = null;
      try {
        tokenData = tokenText ? JSON.parse(tokenText) : null;
      } catch {
        tokenData = null;
      }

      if (!tokenResponse.ok || !tokenData?.access) {
        throw new Error(
          tokenData?.detail ||
            tokenData?.error ||
            "Credenziali non corrette. Riprova."
        );
      }

      const meResponse = await fetch(`${API_URL}/api/me/`, {
        headers: {
          Authorization: `Bearer ${tokenData.access}`,
          Accept: "application/json",
        },
      });

      if (!meResponse.ok) {
        throw new Error("Impossibile verificare il profilo cliente.");
      }

      const me = await meResponse.json();
      const role = (me?.role || "").toUpperCase();

      if (role !== "CLIENTE" && role !== "AGENTE" && role !== "AZIENDA") {
        clearClientAuth();
        throw new Error(
          "Questo accesso Ã¨ riservato esclusivamente ai clienti dell'app."
        );
      }

      localStorage.setItem("access", tokenData.access);
      sessionStorage.setItem("access", tokenData.access);

      if (tokenData.refresh) {
        localStorage.setItem("refresh", tokenData.refresh);
        sessionStorage.setItem("refresh", tokenData.refresh);
      }

      localStorage.setItem("me.username", me.username || "");
      localStorage.setItem("me.role", me.role || "");
      localStorage.setItem("me.store_name", me.store_name || "");
      localStorage.removeItem("session_only");

      window.dispatchEvent(new Event("localstorage-auth"));
      navigate(role === "CLIENTE" ? returnTo : "/app", { replace: true });
    } catch (error) {
      console.error("Login app clienti fallito:", error);

      const message = error?.message || "Errore durante l'accesso";

      setErr(
        message.includes("Failed to fetch")
          ? "Impossibile collegarsi al servizio. Controlla la connessione."
          : message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      style={{
        minHeight: "100vh",
        background: "#f6f2ed",
        padding: "48px 18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div style={{ width: "100%", maxWidth: 430 }}>
        <button
          type="button"
          onClick={() => navigate("/app", { replace: true })}
          disabled={loading}
          style={{
            border: 0,
            background: "transparent",
            color: "#8b0d12",
            fontWeight: 700,
            padding: "0 0 14px 2px",
            cursor: "pointer",
          }}
        >
          &larr; Torna alla Home
        </button>
        <div
          className="card shadow-sm"
          style={{
            border: 0,
            borderRadius: 20,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              background: "#8b0d12",
              color: "white",
              padding: "26px 22px",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 30, marginBottom: 6 }}>ðŸ·</div>

            <h2 style={{ fontSize: 25, margin: 0, fontWeight: 800 }}>
              Dallo Zio Roby
            </h2>

            <div style={{ marginTop: 6, opacity: 0.9 }}>
              Accedi alla tua app clienti
            </div>
          </div>

          <div className="card-body" style={{ padding: 24 }}>
            {err && (
              <div className="alert alert-danger" role="alert">
                {err}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label htmlFor="app-email" className="form-label">
                  Email
                </label>

                <input
                  id="app-email"
                  autoFocus
                  className="form-control"
                  value={username}
                  onChange={(event) => setUsername(event.target.value)}
                  autoComplete="username"
                  inputMode="email"
                  disabled={loading}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="app-password" className="form-label">
                  Password
                </label>

                <div className="input-group">
                  <input
                  id="app-password"
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="current-password"
                  disabled={loading}
                  />
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? "Nascondi password" : "Mostra password"} aria-pressed={showPassword} disabled={loading}>{showPassword ? "🙈" : "👁"}</button>
                </div>
              </div>

              <button
                type="submit"
                className="btn w-100"
                disabled={loading}
                style={{
                  background: "#8b0d12",
                  color: "white",
                  fontWeight: 700,
                  minHeight: 48,
                  borderRadius: 12,
                }}
              >
                {loading ? "Accesso in corso..." : "Accedi"}
              </button>

              <button
                type="button"
                className="btn btn-link w-100 mt-3"
                style={{
                  color: "#8b0d12",
                  textDecoration: "none",
                  fontWeight: 600,
                }}
                onClick={() => navigate("/forgot-password")}
                disabled={loading}
              >
                Password dimenticata?
              </button>

              <div
                className="text-center mt-4 pt-3"
                style={{ borderTop: "1px solid #eee" }}
              >
                <div className="text-muted mb-2">
                  Non hai ancora un account?
                </div>

                <button
                  type="button"
                  className="btn w-100 rounded-pill fw-bold"
                  onClick={() => navigate("/app/register", { state: { returnTo } })}
                  disabled={loading}
                  style={{
                    border: "2px solid #8b0d12",
                    color: "#8b0d12",
                    background: "#fff",
                    minHeight: 46,
                  }}
                >
                  Registrati ora
                </button>
              </div>
            </form>

            <p
              className="text-muted text-center mb-0 mt-3"
              style={{ fontSize: 13 }}
            >
              La sessione resterÃ  attiva su questo dispositivo.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
